import { createFileRoute } from '@tanstack/react-router';
import ActiveFaresPage from '../../../features/patient-transport/pages/ActiveFaresPage';
import { getFaresQueryOptions } from '../../../features/patient-transport/queries';

export const Route = createFileRoute('/_auth/patient-transport/fares/active')({
  component: RouteComponent,
  loader: ({ context: { queryClient, authenticationContext } }) =>
    authenticationContext.user && authenticationContext.user.porter
      ? queryClient.ensureQueryData(getFaresQueryOptions(authenticationContext.user.porter))
      : undefined,
});

function RouteComponent() {
  const { user } = Route.useRouteContext().authenticationContext;

  return <ActiveFaresPage porter={user?.porter} user={user} />;
}
